import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ConfirmDrawer } from "web_myplann/Shared/Components/ConfirmDrawer";

const R = Resources.Finances.LeaveDialog;

type Props = {
	open: boolean;
	onStay: () => void;
	onLeave: () => void;
};

export const LeaveFinancesDrawer: FC<Props> = ({ open, onStay, onLeave }) => {
	const { t } = useResource();

	return (
		<ConfirmDrawer
			open={open}
			title={t(R.title)}
			description={t(R.description)}
			confirmLabel={t(R.leave)}
			cancelLabel={t(R.stay)}
			destructive
			onConfirm={onLeave}
			onClose={onStay}
		/>
	);
};
